<template>
  <div v-page-title="section.title">
    <el-container>
      <el-row>
        <el-col :span="24" style="padding-left: 120px">
          <!--页面导航-->
          <page-nav :pageNavObj="pageNavObj"></page-nav>
        </el-col>
        <el-col :span="24">
          <div class="article-container">
            <div class="ql-container ql-snow" style="border: 0px">
              <div class="ql-editor">
                <span v-html="document.content"></span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-container>
    <!--学习计时器-->
    <document-timer ref="timer"
                    :timeCount="timeCount"
                    :isFree="isFree"
                    :studyStatus="document.userSectionStudyStatus"
                    @completeStudy="completeStudy">
    </document-timer>
  </div>
</template>

<script>
  const PageNav = () => import('@/components/course/PageNav');
  const DocumentTimer = () => import('@/components/course/DocumentTimer');
  export default {
    name: "document",
    components: {
      PageNav,
      DocumentTimer
    },
    data() {
      return {
        course: {}, // 课程对象
        section: {}, //小节对象
        document: {}, //文档对象
        pageNavObj: {}, // 页面导航对象
        timeCount: 0, // 剩余阅读时间
        isFree: false, // 是否免费
      }
    },
    methods: {
      async queryByCourseId(courseId) {
        const {content} = await this.$http.get('/business/web/course/queryById',{params:{courseId:courseId}});
        this.course = content;

        this.initPageNavObj();
      },
      async queryBySectionId(sectionId) {
        const {content} = await this.$http.get('/business/web/section/queryById',{params:{sectionId:sectionId}});
        this.section = content;
        await this.queryByTarget();

        this.initPageNavObj();
      },
      async queryByTarget() {
        const {code,content} = await this.$http.post('/business/web/section/queryByTarget',
          {'sectionId':this.section.id,
            'targetId':this.section.targetId,
            'targetType':this.section.targetType,
            'courseType':'C'});
        console.log(content)
        if (code === '2002') {
          this.$message.error("抱歉,您还未登录 !");
          this.$router.push({ path: '/login' });
        } else if (code === '2003') {
          this.$message.error("抱歉,非本学习班课程 !！");
          this.$router.push({ path: `/home/orderConfirm/${this.section.courseId}`});
        }else if (code === '2001') {
          this.document = content;
          this.isFree = true;
        } else if(code === '2000') {
          this.document = content;
          if (this.document .timeCount != undefined && this.document .timeCount != 0 ) {
            this.timeCount = parseInt( this.document.timeCount);
          }
        }
      },
      initPageNavObj() {
        this.pageNavObj = {
          courseType: this.course.courseType,
          courseId: this.course.id,
          courseName: this.course.name,
          sectionTitle: this.section.title
        }
      },
      // 页面刷新或者关闭
      refreshAndClose() {
        if (!this.isFree && this.document.userSectionStudyStatus != 'Y') {
          // 记录最后阅读时间
          this.recordLastReadTime(parseInt(this.$refs.timer.timeCountSelf));
        }
      },
      async recordLastReadTime(time) {
        await this.$http.post('/business/web/userSection/recordLastTimeAndUpdatimeStatus',
          {"sectionId":this.section.id,"lastPlayTime":time});
      },
      async completeStudy() {
        if (this.document.userSectionStudyStatus !== 'Y') {
          const {success} = await this.$http.post('/business/web/userSection/completeSectionStudy',
            {"courseId":this.course.id,"sectionId":this.section.id});
          if (success) {
            this.recordLastReadTime(0);
            this.document.userSectionStudyStatus = 'Y';
            this.$message.success("您已完成本小节的学习啦！")
          }
        }
      },
    },
    // 路由更新
    beforeRouteLeave (to, from, next) {
      // 记录最后阅读时间
      if (!this.isFree) {
        this.recordLastReadTime(parseInt(this.$refs.timer.timeCountSelf));
      }
      next();
    },
    created() {
      // 监控页面刷新和关闭
      window.addEventListener('beforeunload', e => this.refreshAndClose(e));
    },
    mounted() {
      let courseId = this.$route.params.courseId;
      let sectionId = this.$route.params.sectionId;

      if (courseId){
        this.queryByCourseId(courseId);
      }
      if (sectionId){
        this.queryBySectionId(sectionId);
      }
    }
  }
</script>

<style scoped>
  .el-container {
    width: 1200px;
    min-width: 1200px;
    margin: 35px auto 50px auto;
  }

  .article-container {
    margin: 0 auto;
    padding: 20px 30px 24px 30px;
    width: 900px;
    min-height: 600px;
    background-color: white;
    border-radius: 3px 3px 3px 3px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  }
</style>
